import { remoteDomainsPath } from 'app/constants';
import { QueryKeys, useDeleteRemoteDomain } from 'data';
import DeleteModal, { IDeleteModalProps } from '../delete-modal';

export const RemoteDomainDeleteModal = ({ entityName, onClose, onSettled }: IDeleteModalProps) => {
  const { mutate: deleteDomain, isLoading: isDomainDeleting } = useDeleteRemoteDomain();

  return (
    <DeleteModal
      title="Remove remote domain?"
      modalText={`Are you sure you want to remove ${entityName} ?`}
      entityName={entityName}
      successMessage={
        <div>
          Remote domain <strong>{entityName}</strong> was removed
        </div>
      }
      redirectPath={remoteDomainsPath}
      queryKey={QueryKeys.REMOTE_DOMAINS}
      deleteMethod={deleteDomain}
      onClose={onClose}
      onSettled={onSettled}
      isLoading={isDomainDeleting}
    />
  );
};
